import type { GuestPrivilegeApi } from "../../api/GuestPrivilegeApi";
import type { GuestPrivilegeFetchOptions } from "../../generated/dto/GuestPrivilegeFetchOptions";
import type { GuestPrivilegeStaff } from "../../generated/dto/GuestPrivilegeStaff";
import type { MembershipStaff } from "../../generated/dto/MembershipStaff";
import type { MembershipStaffFetchOptions } from "../../generated/dto/MembershipStaffFetchOptions";

export class GuestPrivilegeFrontendService {
  constructor(private readonly api: GuestPrivilegeApi) {}
  async getGuestPrivilegeStaff(id: number, options?: GuestPrivilegeFetchOptions): Promise<GuestPrivilegeStaff> {
    return this.api.getGuestPrivilegeStaff(id, options)
  }
  async getGuestPrivilegeStaffMembershipId(id: number, options?: MembershipStaffFetchOptions): Promise<MembershipStaff> {
    return this.api.getGuestPrivilegeStaffMembershipId(id, options)
  }
}
